import MaterialReactTable from 'material-react-table';
import Sort from 'apm/assets/icon/Sort';

const Table = ({ muiTableBodyProps, ...rest }) => {
  return (
    <MaterialReactTable
      editingMode="table"
      enableColumnActions={false}
      enableTopToolbar={false}
      icons={{ ArrowDownwardIcon: (props) => <Sort {...props} /> }}
      muiTableBodyProps={{
        ...muiTableBodyProps,
        sx: {
          '& tr:nth-of-type(even)': { backgroundColor: '#F2F5F8' },
          '& td,& td a': { color: '#1B2064' },
        },
      }}
      {...rest}
    />
  );
};

export default Table;
